module.exports = __webpack_public_path__ + "img/how_to_complete_task_video.dca43038.jpg";